import { useEffect, useState } from 'react';
import { FaArrowLeft, FaDollarSign, FaSave, FaTag, FaUsers, FaWarehouse, FaClipboardList, FaAlignLeft } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';

const ProductForm = ({ initial = {}, onSubmit, submitLabel = 'Save product', onCancel }) => {
  const { t } = useTranslation();
  const [form, setForm] = useState({
    name: initial.name || '',
    stock: initial.stock ?? 0,
    totalRequired: initial.totalRequired ?? 0,
    customersWaiting: initial.customersWaiting ?? 0,
    description: initial.description || '',
    price: initial.price ?? 0,
  });

  useEffect(() => {
    setForm({
      name: initial.name || '',
      stock: initial.stock ?? 0,
      totalRequired: initial.totalRequired ?? 0,
      customersWaiting: initial.customersWaiting ?? 0,
      description: initial.description || '',
      price: initial.price ?? 0,
    });
  }, [initial]);

  const change = (e) => {
    const { name, value } = e.target;
    setForm((f) => ({ ...f, [name]: name === 'name' || name === 'description' ? value : Number(value) }));
  };

  const submit = (e) => {
    e.preventDefault();
    onSubmit(form);
  };

  return (
    <form onSubmit={submit} className="space-y-6">
      <div>
        <label className="flex items-center gap-2 text-sm font-medium text-slate-700">
          <FaTag className="text-sky-500" /> {t('dashboard.common.name')}
        </label>
        <input name="name" value={form.name} onChange={change} className="mt-1 block w-full rounded-lg border border-slate-200 bg-white px-4 py-3 shadow-sm focus:border-sky-400 focus:outline-none focus:ring-2 focus:ring-sky-200" required />
      </div>

      <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
        <div>
          <label className="flex items-center gap-2 text-sm font-medium text-slate-700">
            <FaWarehouse className="text-emerald-500" /> {t('dashboard.products.stock')}
          </label>
          <input name="stock" type="number" value={form.stock} onChange={change} className="mt-1 block w-full rounded-lg border border-slate-200 bg-white px-4 py-3 shadow-sm focus:border-sky-400 focus:outline-none focus:ring-2 focus:ring-sky-200" />
        </div>
        <div>
          <label className="flex items-center gap-2 text-sm font-medium text-slate-700">
            <FaClipboardList className="text-indigo-500" /> {t('dashboard.products.required')}
          </label>
          <input name="totalRequired" type="number" value={form.totalRequired} onChange={change} className="mt-1 block w-full rounded-lg border border-slate-200 bg-white px-4 py-3 shadow-sm focus:border-sky-400 focus:outline-none focus:ring-2 focus:ring-sky-200" />
        </div>
        <div>
          <label className="flex items-center gap-2 text-sm font-medium text-slate-700">
            <FaUsers className="text-fuchsia-500" /> {t('dashboard.products.waiting')}
          </label>
          <input name="customersWaiting" type="number" value={form.customersWaiting} onChange={change} className="mt-1 block w-full rounded-lg border border-slate-200 bg-white px-4 py-3 shadow-sm focus:border-sky-400 focus:outline-none focus:ring-2 focus:ring-sky-200" />
        </div>
      </div>

      <div>
        <label className="flex items-center gap-2 text-sm font-medium text-slate-700">
          <FaDollarSign className="text-amber-500" /> {t('dashboard.products.price')}
        </label>
        <input name="price" type="number" step="0.01" value={form.price} onChange={change} className="mt-1 block w-full rounded-lg border border-slate-200 bg-white px-4 py-3 shadow-sm focus:border-sky-400 focus:outline-none focus:ring-2 focus:ring-sky-200" />
      </div>

      <div>
        <label className="flex items-center gap-2 text-sm font-medium text-slate-700">
          <FaAlignLeft className="text-slate-400" /> {t('dashboard.common.description')}
        </label>
        <textarea name="description" value={form.description} onChange={change} className="mt-1 block w-full rounded-lg border border-slate-200 bg-white px-4 py-3 shadow-sm focus:border-sky-400 focus:outline-none focus:ring-2 focus:ring-sky-200" rows={4} />
      </div>

      <div className="flex flex-col gap-3 sm:flex-row sm:items-center">
        <button type="submit" className="inline-flex items-center justify-center gap-2 rounded-md bg-[#00595A] px-5 py-3 text-sm font-semibold text-white shadow-sm transition hover:bg-[#004446]">
          <FaSave className="h-4 w-4" /> {submitLabel}
        </button>
        {onCancel ? (
          <button
            type="button"
            onClick={onCancel}
            className="inline-flex items-center justify-center gap-2 rounded-md bg-slate-100 px-5 py-3 text-sm font-semibold text-slate-700 transition hover:bg-slate-200"
          >
            <FaArrowLeft className="h-4 w-4" /> {t('dashboard.common.back')}
          </button>
        ) : null}
      </div>
    </form>
  );
};

export default ProductForm;
